import YoungPersonMoveOut from './YoungPersonMoveOut';
export default YoungPersonMoveOut;
